export default __webpack_public_path__ + "static/sportplus-casestudy-5ef863d14567ff67ff30e1c31646d6da.png";